import { fetchAdminUsersExportCsv } from './fetchAdminUsersExportCsv';
import type {
  AdminUsersExportCsvErrorKind,
  FetchAdminUsersExportCsvOptions,
} from './fetchAdminUsersExportCsv';

export type DownloadAdminUsersCsvResult =
  | { ok: true }
  | { ok: false; kind: AdminUsersExportCsvErrorKind; status?: number };

/** Default when the server omits Content-Disposition (matches backend curl example). */
export function defaultAdminUsersExportFilename(): string {
  return 'users-export.csv';
}

function safeDownloadFilename(name: string): string {
  const trimmed = name.trim();
  if (!trimmed) return defaultAdminUsersExportFilename();
  if (/\.csv$/i.test(trimmed)) return trimmed;
  return `${trimmed}.csv`;
}

export async function downloadAdminUsersCsv(
  idToken: string | null | undefined,
  options?: FetchAdminUsersExportCsvOptions
): Promise<DownloadAdminUsersCsvResult> {
  const result = await fetchAdminUsersExportCsv(idToken, options);
  if (!result.ok) {
    return { ok: false, kind: result.kind, status: result.status };
  }

  const filename = safeDownloadFilename(
    result.suggestedFilename?.trim() || defaultAdminUsersExportFilename()
  );
  const url = URL.createObjectURL(result.blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);

  return { ok: true };
}
